const KEY = "nutriscan_scan_days";
const dayStr = (d) => new Date(d).toISOString().slice(0, 10);

export const recordScanDay = () => {
  try {
    const days = new Set(JSON.parse(localStorage.getItem(KEY)) || []);
    days.add(dayStr(Date.now()));
    localStorage.setItem(KEY, JSON.stringify([...days]));
  } catch { /* noop */ }
};

export const getStreak = () => {
  let days;
  try { days = JSON.parse(localStorage.getItem(KEY)) || []; } catch { days = []; }
  const set = new Set(days);
  if (!set.size) return { current: 0, total: 0 };
  const today = new Date();
  const yest = new Date(today); yest.setDate(yest.getDate() - 1);
  let cursor;
  if (set.has(dayStr(today))) cursor = new Date(today);
  else if (set.has(dayStr(yest))) cursor = new Date(yest);
  else return { current: 0, total: set.size };
  let current = 0;
  while (set.has(dayStr(cursor))) {
    current += 1;
    cursor.setDate(cursor.getDate() - 1);
  }
  return { current, total: set.size };
};
